import { CountryCreate } from './CountryCreate';
import { CountryEdit } from './CountryEdit';
import { CountryList } from './CountryList';
import { CountryShow } from './CountryShow';

export const create = CountryCreate;
export const edit = CountryEdit;
export const list = CountryList;
export const show = CountryShow;
